import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { HomeLayout } from "../components/layout/HomeLayout";
import { HubEditorialGrid, type HubEditorialItem } from "../components/home/HubEditorialGrid";
import { HOME_THEME as C } from "../lib/homeTheme";

const EXPLORE_ITEMS: HubEditorialItem[] = [
  {
    id: "scales",
    title: "Escalas",
    description: "Explorador libre de escalas en el mástil.",
    path: "/scales/explorer",
    accent: "lavender",
  },
  {
    id: "chords",
    title: "Acordes",
    description: "Constructor de acordes y voicings.",
    path: "/chords/explorer",
    accent: "mint",
  },
  {
    id: "modos",
    title: "Modos",
    description: "Modos griegos y sonoridades.",
    path: "/modos",
    accent: "lavender",
  },
  {
    id: "notas",
    title: "Notas",
    description: "Ubica notas en el instrumento.",
    path: "/notas",
    accent: "mint",
  },
  {
    id: "melodies",
    title: "Melodías",
    description: "Practica frases melódicas.",
    path: "/melodies",
    accent: "lavender",
  },
  {
    id: "songbook",
    title: "Songbook",
    description: "Letras, acordes y práctica libre.",
    path: "/songbook",
    accent: "mint",
  },
];

export const ExploreHubPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <HomeLayout>
      <div className="mx-auto max-w-7xl px-8 py-10 pb-24">
        <button
          type="button"
          onClick={() => navigate("/home")}
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.14em] uppercase transition-colors duration-300 hover:text-[#c4b5fd]"
          style={{ color: C.muted }}
        >
          <ArrowLeft className="h-4 w-4" />
          Inicio
        </button>

        <header className="mt-10 mb-16 max-w-3xl text-left">
          <p
            className="text-xs tracking-widest uppercase"
            style={{ color: "rgba(196, 181, 253, 0.5)" }}
          >
            Explorar
          </p>
          <h1
            className="mt-4 font-serif font-light tracking-tight text-left text-[clamp(3rem,8vw,4.5rem)] leading-[0.95]"
            style={{ color: C.text }}
          >
            Sandbox libre
          </h1>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-left text-white/60">
            Sin misiones ni puntaje obligatorio. Descubre escalas, acordes, modos y más a tu ritmo.
          </p>
        </header>

        <HubEditorialGrid items={EXPLORE_ITEMS} />
      </div>
    </HomeLayout>
  );
};

export default ExploreHubPage;
